export const imageHostURL = process.env.REACT_APP_IMAGE_HOST_URL